/* global require */
import * as React from "react";
import fetch from "node-fetch";
import { makeStyles } from "@fluentui/react-components";
import Login from "./Login";
import Home from "./Home";
import { LocalStorageKey as Keys, getLocalStorage, removeLocalStorage, setLocalStorage } from "..";

const config = require("config");

interface AppProps {}

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App: React.FC<AppProps> = () => {
  const styles = useStyles();

  const [accessToken, setAccessToken] = React.useState(getLocalStorage(Keys.AccessToken));
  const [sessionId, setSessionId] = React.useState(getLocalStorage(Keys.SessionId));
  const [showLogin, setShowLogin] = React.useState(false);

  React.useEffect(() => {
    checkAccessToken();
  }, []);

  async function checkAccessToken() {
    const accessToken = getLocalStorage(Keys.AccessToken);
    const sessionId = getLocalStorage(Keys.SessionId);
    if (!accessToken || !sessionId) {
      return;
    }

    await fetch(config.apiUrl + "/profile/info", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
        "x-session-id": sessionId,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }

        removeLocalStorage(Keys.AccessToken);
        removeLocalStorage(Keys.SessionId);
        return null;
      })
      .then((res) => {
        if (res?.success !== true) {
          removeLocalStorage(Keys.AccessToken);
          removeLocalStorage(Keys.SessionId);
        }
      })
      .catch(() => {
        // If the api is unreachable (e.g., no wifi), this code block will run.
        // The user's access token should still be kept, so there is no code to run here lol.
      });
  }

  function login(token: string, sessionId: string) {
    setLocalStorage(Keys.AccessToken, token);
    setLocalStorage(Keys.SessionId, sessionId);
    setAccessToken(token);
    setSessionId(sessionId);
    setShowLogin(false);
  }

  function logout() {
    removeLocalStorage(Keys.AccessToken);
    removeLocalStorage(Keys.SessionId);
    setAccessToken(null);
    setSessionId(null);
    setShowLogin(true);
  }

  return (
    <div className={styles.root}>
      {showLogin ? (
        <Login close={() => setShowLogin(false)} login={login} />
      ) : (
        <Home
          accessToken={accessToken}
          sessionId={sessionId}
          logout={logout}
          showLogin={() => setShowLogin(true)}
        />
      )}
    </div>
  );
};

export default App;
